import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="promoters--event-groups"
export default class extends Controller {
  static targets = ["halfModal", "selectLabel", "selectOption", "form"];

  select(event) {
    const selectedText = event.target.textContent.trim();
    const selectedElement = event.target.closest("li");
    const sortParam = selectedElement.dataset.sortParam;
    this.updateSelection(selectedText, selectedElement, sortParam);
    const form = document.getElementById("search_form");
    const sortField = form.querySelector('input[name="q[s]"]');
    sortField.value = sortParam;
    form.requestSubmit();
  }

  updateSelection(selectedText, selectedElement, sortParam) {
    this.selectLabelTarget.textContent = selectedText;
    this.selectLabelTarget.dataset.sortParam = sortParam;
    this.selectOptionTargets.forEach((option) => option.classList.remove("is-selected"));
    selectedElement.classList.add("is-selected");
    this.halfModalTarget.classList.remove("is-open");
  }

  modalShow(event) {
    const targetId = event.currentTarget.dataset.targetId;
    const eventGroupName = event.currentTarget.dataset.eventGroupName;
    const eventGroupId = event.currentTarget.dataset.eventGroupId;
    const target = document.getElementById(targetId);
    const modalController = this.application.getControllerForElementAndIdentifier(target, "modal");

    target.getElementsByClassName("modal-dialog_event-group-name-text")[0].textContent = eventGroupName;
    target.getElementsByClassName("modal-dialog_event-group-copy")[0].value = eventGroupId;

    modalController.show();
  }

  // 隠しフォームを送信する処理
  submitPreviewForm(event) {
    event.preventDefault(); // デフォルトのリンク動作を防止

    // 隠しフォームとそのフィールドを取得
    const form = document.querySelector("#hidden-preview-form");
    const eventGroupIdInput = document.querySelector("#hidden-preview-event-group-id");
    const promoterIdInput = document.querySelector("#hidden-preview-promoter-id");

    // HTMLデータ属性から値を取得してフォームフィールドを更新
    const eventGroupId = event.currentTarget.dataset.eventGroupId;
    const promoterId = event.currentTarget.dataset.promoterId;

    if (form && eventGroupId && promoterId) {
      eventGroupIdInput.value = eventGroupId;
      promoterIdInput.value = promoterId;

      // フォーム送信
      form.target = "_blank";
      form.submit();
    } else {
      console.error("フォームまたは必要なデータが見つかりません");
    }
  }
}
